import { cn } from 'cn';
import type { HTMLProps, ReactNode, RefObject } from 'react';

export type CheckboxProps = HTMLProps<HTMLInputElement> & {
  refElement?: RefObject<HTMLInputElement | null>;
  variant?: 'default' | 'list';
  error?: boolean;
  required?: boolean;
  labelElement?: string | ReactNode;
  labelClassName?: string;
  outerClassName?: string;
};

function Checkbox(props: CheckboxProps) {
  const {
    name,
    id,
    outerClassName,
    className,
    labelElement,
    labelClassName,
    onChange,
    refElement,
    checked,
    disabled,
    variant = 'default',
    error = false,
    required = false,
  } = props;

  return (
    <label
      htmlFor={id}
      className={cn(
        'typ-ui group flex select-none items-center',
        {
          'gap-x-2 rounded': labelElement,
          'bg-neutral-0 focus-within:border-blue-10 focus-within:bg-neutral-5 focus-within:ring-blue-10 border-neutral-10 kunde:px-4 kunde:py-4 kunde:gap-x-4 border px-2 py-1 focus-within:ring-1':
            variant === 'list' && labelElement,
          'bg-neutral-5': checked && variant === 'list' && labelElement,
          'hover:text-blue-60 cursor-pointer text-black': !disabled,
          'hover:text-neutral-60 text-neutral-60 cursor-default': disabled,
        },
        outerClassName,
      )}
    >
      <input
        ref={refElement}
        name={name}
        className={cn(
          'checkbox group-hover:border-blue-60 shrink-0',
          {
            'group-disabled:border-0': !error,
            'border-0 hover:border-0': disabled,
            error: error,
          },
          className,
        )}
        id={id}
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      {labelElement ? (
        <span
          id={`${id}-label`}
          className={cn(
            'typ-ui-sm-bold kunde:typ-body flex grow',
            checked && labelClassName,
          )}
        >
          {labelElement}
          {required ? <span className={'text-red-100'}>*</span> : null}
        </span>
      ) : null}
    </label>
  );
}

export default Checkbox;
